import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { UserFilterDto, UserItemDto, UserService, } from '@artemis-software/wr-api';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CurrentUserService } from '@services/current-user.service';

@Component({
  standalone: false,
  selector: 'wr-admin-user-overview-page',
  styleUrls: ['./admin-user-overview-page.component.scss'],
  templateUrl: './admin-user-overview-page.component.html',
})
export class AdminUserOverviewPageComponent {

  private readonly router = inject(Router);
  private readonly formBuilder = inject(FormBuilder);
  private readonly userService = inject(UserService);
  private readonly currentUserService = inject(CurrentUserService);

  canCreate = computed(() => this.currentUserService.hasPrivilege('canCreateUsersAdmin'));

  form!: FormGroup;

  readonly loadUsers = (filter: UserFilterDto) => this.userService.findAll(filter);
  readonly getCount = (filter: UserFilterDto) => this.userService.getCount(filter);

  constructor() {
    this.form = this.formBuilder.group({
      text: this.formBuilder.control(''),
      tenantId: this.formBuilder.control(''),
    });
  }

  get queryParams() {
    return { queryParams: { mode: 'admin' } };
  }

  navigateToUser(user: UserItemDto): void {
    this.router.navigate(['user', user.id], this.queryParams);
  }

  add(): void {
    this.router.navigate(['user', 'new'], this.queryParams);
  }
}
